// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1rRdh","obliqueLineWrap":"membershipbadge_obliqueLineWrap__21s3T","obliqueLine":"membershipbadge_obliqueLine__aNwey"};